module.exports = __webpack_public_path__ + "img/writing.f841bf40.jpeg";